import styled from 'styled-components';

export const FooterContainer = styled.div`
  position: relative;
  z-index: 1;
  flex-shrink: 0;
  width: 100%;
  color: ${({ theme }) => theme.color.chatPanel};
  font-size: ${({ theme }) => theme.font.size.small};
`;

export const FooterContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  gap: 4px;
  width: 100%;
`;

export const FooterText = styled.div`
  color: inherit;
  flex: ${({ theme }) => (theme ? '0 1 auto' : '1')};
`;
